import { createSlice } from "@reduxjs/toolkit";

const selectProductIdSlice = createSlice({
    name: "selectProductId",
    initialState: {
        selectProductId: null,
    },
    reducers: {
        setSelectedProductId: (state, action) => {
            state.selectProductId = action.payload;
        },
    },
});

export const { setSelectedProductId } = selectProductIdSlice.actions;
export default selectProductIdSlice.reducer;
